import { KeycloakConfig } from 'keycloak-js';

export const keycloakConfig: KeycloakConfig = {
  url: 'https://dev.clinitrix.ch/auth',
  realm: 'ZGIS',
  clientId: 'portal',
};
